module.exports = __webpack_public_path__ + "img/1.1b52b6d.jpg";